export const LLM_OPTIONS: { value: string; label: string }[] = [
  { value: "ai21/jamba-large-1.7", label: "ai21/jamba-large-1.7" },
  { value: "aion-labs/aion-1.0", label: "aion-labs/aion-1.0" },
  { value: "aion-labs/aion-1.0-mini", label: "aion-labs/aion-1.0-mini" },
  { value: "aion-labs/aion-2.0", label: "aion-labs/aion-2.0" },
  { value: "aion-labs/aion-rp-llama-3.1-8b", label: "aion-labs/aion-rp-llama-3.1-8b" },
  { value: "alfredpros/codellama-7b-instruct-solidity", label: "alfredpros/codellama-7b-instruct-solidity" },
  { value: "alibaba/tongyi-deepresearch-30b-a3b", label: "alibaba/tongyi-deepresearch-30b-a3b" },
  { value: "allenai/molmo-2-8b", label: "allenai/molmo-2-8b" },
  { value: "allenai/olmo-2-0325-32b-instruct", label: "allenai/olmo-2-0325-32b-instruct" },
  { value: "allenai/olmo-3-32b-think", label: "allenai/olmo-3-32b-think" },
  { value: "allenai/olmo-3-7b-instruct", label: "allenai/olmo-3-7b-instruct" },
  { value: "allenai/olmo-3-7b-think", label: "allenai/olmo-3-7b-think" },
  { value: "allenai/olmo-3.1-32b-instruct", label: "allenai/olmo-3.1-32b-instruct" },
  { value: "allenai/olmo-3.1-32b-think", label: "allenai/olmo-3.1-32b-think" },
  { value: "alpindale/goliath-120b", label: "alpindale/goliath-120b" },
  { value: "amazon/nova-2-lite-v1", label: "amazon/nova-2-lite-v1" },
  { value: "amazon/nova-lite-v1", label: "amazon/nova-lite-v1" },
  { value: "amazon/nova-micro-v1", label: "amazon/nova-micro-v1" },
  { value: "amazon/nova-premier-v1", label: "amazon/nova-premier-v1" },
  { value: "amazon/nova-pro-v1", label: "amazon/nova-pro-v1" },
  { value: "anthracite-org/magnum-v4-72b", label: "anthracite-org/magnum-v4-72b" },
  { value: "anthropic/claude-3-haiku", label: "anthropic/claude-3-haiku" },
  { value: "anthropic/claude-3.5-haiku", label: "anthropic/claude-3.5-haiku" },
  { value: "anthropic/claude-3.5-sonnet", label: "anthropic/claude-3.5-sonnet" },
  { value: "anthropic/claude-3.7-sonnet", label: "anthropic/claude-3.7-sonnet" },
  { value: "anthropic/claude-3.7-sonnet:thinking", label: "anthropic/claude-3.7-sonnet:thinking" },
  { value: "anthropic/claude-haiku-4.5", label: "anthropic/claude-haiku-4.5" },
  { value: "anthropic/claude-opus-4", label: "anthropic/claude-opus-4" },
  { value: "anthropic/claude-opus-4.1", label: "anthropic/claude-opus-4.1" },
  { value: "anthropic/claude-opus-4.5", label: "anthropic/claude-opus-4.5" },
  { value: "anthropic/claude-opus-4.6", label: "anthropic/claude-opus-4.6" },
  { value: "anthropic/claude-sonnet-4", label: "anthropic/claude-sonnet-4" },
  { value: "anthropic/claude-sonnet-4.5", label: "anthropic/claude-sonnet-4.5" },
  { value: "anthropic/claude-sonnet-4.6", label: "anthropic/claude-sonnet-4.6" },
  { value: "arcee-ai/coder-large", label: "arcee-ai/coder-large" },
  { value: "arcee-ai/maestro-reasoning", label: "arcee-ai/maestro-reasoning" },
  { value: "arcee-ai/spotlight", label: "arcee-ai/spotlight" },
  { value: "arcee-ai/trinity-large-preview:free", label: "arcee-ai/trinity-large-preview:free" },
  { value: "arcee-ai/trinity-mini", label: "arcee-ai/trinity-mini" },
  { value: "arcee-ai/trinity-mini:free", label: "arcee-ai/trinity-mini:free" },
  { value: "arcee-ai/virtuoso-large", label: "arcee-ai/virtuoso-large" },
  { value: "baidu/ernie-4.5-21b-a3b", label: "baidu/ernie-4.5-21b-a3b" },
  { value: "baidu/ernie-4.5-21b-a3b-thinking", label: "baidu/ernie-4.5-21b-a3b-thinking" },
  { value: "baidu/ernie-4.5-300b-a47b", label: "baidu/ernie-4.5-300b-a47b" },
  { value: "baidu/ernie-4.5-vl-28b-a3b", label: "baidu/ernie-4.5-vl-28b-a3b" },
  { value: "baidu/ernie-4.5-vl-424b-a47b", label: "baidu/ernie-4.5-vl-424b-a47b" },
  { value: "bytedance-seed/seed-1.6", label: "bytedance-seed/seed-1.6" },
  { value: "bytedance-seed/seed-1.6-flash", label: "bytedance-seed/seed-1.6-flash" },
  { value: "bytedance-seed/seed-2.0-lite", label: "bytedance-seed/seed-2.0-lite" },
  { value: "bytedance-seed/seed-2.0-mini", label: "bytedance-seed/seed-2.0-mini" },
  { value: "bytedance/ui-tars-1.5-7b", label: "bytedance/ui-tars-1.5-7b" },
  { value: "cognitivecomputations/dolphin-mistral-24b-venice-edition:free", label: "cognitivecomputations/dolphin-mistral-24b-venice-edition:free" },
  { value: "cohere/command-a", label: "cohere/command-a" },
  { value: "cohere/command-r-08-2024", label: "cohere/command-r-08-2024" },
  { value: "cohere/command-r-plus-08-2024", label: "cohere/command-r-plus-08-2024" },
  { value: "cohere/command-r7b-12-2024", label: "cohere/command-r7b-12-2024" },
  { value: "deepcogito/cogito-v2.1-671b", label: "deepcogito/cogito-v2.1-671b" },
  { value: "deepseek/deepseek-chat", label: "deepseek/deepseek-chat" },
  { value: "deepseek/deepseek-chat-v3-0324", label: "deepseek/deepseek-chat-v3-0324" },
  { value: "deepseek/deepseek-chat-v3.1", label: "deepseek/deepseek-chat-v3.1" },
  { value: "deepseek/deepseek-r1", label: "deepseek/deepseek-r1" },
  { value: "deepseek/deepseek-r1-0528", label: "deepseek/deepseek-r1-0528" },
  { value: "deepseek/deepseek-r1-distill-llama-70b", label: "deepseek/deepseek-r1-distill-llama-70b" },
  { value: "deepseek/deepseek-r1-distill-qwen-32b", label: "deepseek/deepseek-r1-distill-qwen-32b" },
  { value: "deepseek/deepseek-v3.1-terminus", label: "deepseek/deepseek-v3.1-terminus" },
  { value: "deepseek/deepseek-v3.2", label: "deepseek/deepseek-v3.2" },
  { value: "deepseek/deepseek-v3.2-exp", label: "deepseek/deepseek-v3.2-exp" },
  { value: "deepseek/deepseek-v3.2-speciale", label: "deepseek/deepseek-v3.2-speciale" },
  { value: "eleutherai/llemma_7b", label: "eleutherai/llemma_7b" },
  { value: "essentialai/rnj-1-instruct", label: "essentialai/rnj-1-instruct" },
  { value: "google/gemini-2.0-flash-001", label: "google/gemini-2.0-flash-001" },
  { value: "google/gemini-2.0-flash-lite-001", label: "google/gemini-2.0-flash-lite-001" },
  { value: "google/gemini-2.5-flash", label: "google/gemini-2.5-flash" },
  { value: "google/gemini-2.5-flash-image", label: "google/gemini-2.5-flash-image" },
  { value: "google/gemini-2.5-flash-lite", label: "google/gemini-2.5-flash-lite" },
  { value: "google/gemini-2.5-flash-lite-preview-09-2025", label: "google/gemini-2.5-flash-lite-preview-09-2025" },
  { value: "google/gemini-2.5-pro", label: "google/gemini-2.5-pro" },
  { value: "google/gemini-2.5-pro-preview", label: "google/gemini-2.5-pro-preview" },
  { value: "google/gemini-2.5-pro-preview-05-06", label: "google/gemini-2.5-pro-preview-05-06" },
  { value: "google/gemini-3-flash-preview", label: "google/gemini-3-flash-preview" },
  { value: "google/gemini-3-pro-image-preview", label: "google/gemini-3-pro-image-preview" },
  { value: "google/gemini-3-pro-preview", label: "google/gemini-3-pro-preview" },
  { value: "google/gemini-3.1-flash-image-preview", label: "google/gemini-3.1-flash-image-preview" },
  { value: "google/gemini-3.1-flash-lite-preview", label: "google/gemini-3.1-flash-lite-preview" },
  { value: "google/gemini-3.1-pro-preview", label: "google/gemini-3.1-pro-preview" },
  { value: "google/gemini-3.1-pro-preview-customtools", label: "google/gemini-3.1-pro-preview-customtools" },
  { value: "google/gemma-2-27b-it", label: "google/gemma-2-27b-it" },
  { value: "google/gemma-2-9b-it", label: "google/gemma-2-9b-it" },
  { value: "google/gemma-3-12b-it", label: "google/gemma-3-12b-it" },
  { value: "google/gemma-3-12b-it:free", label: "google/gemma-3-12b-it:free" },
  { value: "google/gemma-3-27b-it", label: "google/gemma-3-27b-it" },
  { value: "google/gemma-3-27b-it:free", label: "google/gemma-3-27b-it:free" },
  { value: "google/gemma-3-4b-it", label: "google/gemma-3-4b-it" },
  { value: "google/gemma-3-4b-it:free", label: "google/gemma-3-4b-it:free" },
  { value: "google/gemma-3n-e2b-it:free", label: "google/gemma-3n-e2b-it:free" },
  { value: "google/gemma-3n-e4b-it", label: "google/gemma-3n-e4b-it" },
  { value: "google/gemma-3n-e4b-it:free", label: "google/gemma-3n-e4b-it:free" },
  { value: "gryphe/mythomax-l2-13b", label: "gryphe/mythomax-l2-13b" },
  { value: "ibm-granite/granite-4.0-h-micro", label: "ibm-granite/granite-4.0-h-micro" },
  { value: "inception/mercury", label: "inception/mercury" },
  { value: "inception/mercury-2", label: "inception/mercury-2" },
  { value: "inception/mercury-coder", label: "inception/mercury-coder" },
  { value: "inflection/inflection-3-pi", label: "inflection/inflection-3-pi" },
  { value: "inflection/inflection-3-productivity", label: "inflection/inflection-3-productivity" },
  { value: "kwaipilot/kat-coder-pro", label: "kwaipilot/kat-coder-pro" },
  { value: "liquid/lfm-2-24b-a2b", label: "liquid/lfm-2-24b-a2b" },
  { value: "liquid/lfm-2.2-6b", label: "liquid/lfm-2.2-6b" },
  { value: "liquid/lfm-2.5-1.2b-instruct:free", label: "liquid/lfm-2.5-1.2b-instruct:free" },
  { value: "liquid/lfm-2.5-1.2b-thinking:free", label: "liquid/lfm-2.5-1.2b-thinking:free" },
  { value: "liquid/lfm2-8b-a1b", label: "liquid/lfm2-8b-a1b" },
  { value: "mancer/weaver", label: "mancer/weaver" },
  { value: "meituan/longcat-flash-chat", label: "meituan/longcat-flash-chat" },
  { value: "meta-llama/llama-3-70b-instruct", label: "meta-llama/llama-3-70b-instruct" },
  { value: "meta-llama/llama-3-8b-instruct", label: "meta-llama/llama-3-8b-instruct" },
  { value: "meta-llama/llama-3.1-405b", label: "meta-llama/llama-3.1-405b" },
  { value: "meta-llama/llama-3.1-70b-instruct", label: "meta-llama/llama-3.1-70b-instruct" },
  { value: "meta-llama/llama-3.1-8b-instruct", label: "meta-llama/llama-3.1-8b-instruct" },
  { value: "meta-llama/llama-3.2-11b-vision-instruct", label: "meta-llama/llama-3.2-11b-vision-instruct" },
  { value: "meta-llama/llama-3.2-1b-instruct", label: "meta-llama/llama-3.2-1b-instruct" },
  { value: "meta-llama/llama-3.2-3b-instruct", label: "meta-llama/llama-3.2-3b-instruct" },
  { value: "meta-llama/llama-3.2-3b-instruct:free", label: "meta-llama/llama-3.2-3b-instruct:free" },
  { value: "meta-llama/llama-3.3-70b-instruct", label: "meta-llama/llama-3.3-70b-instruct" },
  { value: "meta-llama/llama-3.3-70b-instruct:free", label: "meta-llama/llama-3.3-70b-instruct:free" },
  { value: "meta-llama/llama-4-maverick", label: "meta-llama/llama-4-maverick" },
  { value: "meta-llama/llama-4-scout", label: "meta-llama/llama-4-scout" },
  { value: "meta-llama/llama-guard-3-8b", label: "meta-llama/llama-guard-3-8b" },
  { value: "meta-llama/llama-guard-4-12b", label: "meta-llama/llama-guard-4-12b" },
  { value: "microsoft/phi-4", label: "microsoft/phi-4" },
  { value: "microsoft/wizardlm-2-8x22b", label: "microsoft/wizardlm-2-8x22b" },
  { value: "minimax/minimax-01", label: "minimax/minimax-01" },
  { value: "minimax/minimax-m1", label: "minimax/minimax-m1" },
  { value: "minimax/minimax-m2", label: "minimax/minimax-m2" },
  { value: "minimax/minimax-m2-her", label: "minimax/minimax-m2-her" },
  { value: "minimax/minimax-m2.1", label: "minimax/minimax-m2.1" },
  { value: "minimax/minimax-m2.5", label: "minimax/minimax-m2.5" },
  { value: "minimax/minimax-m2.5:free", label: "minimax/minimax-m2.5:free" },
  { value: "mistralai/codestral-2508", label: "mistralai/codestral-2508" },
  { value: "mistralai/devstral-2512", label: "mistralai/devstral-2512" },
  { value: "mistralai/devstral-medium", label: "mistralai/devstral-medium" },
  { value: "mistralai/devstral-small", label: "mistralai/devstral-small" },
  { value: "mistralai/ministral-14b-2512", label: "mistralai/ministral-14b-2512" },
  { value: "mistralai/ministral-3b-2512", label: "mistralai/ministral-3b-2512" },
  { value: "mistralai/ministral-8b-2512", label: "mistralai/ministral-8b-2512" },
  { value: "mistralai/mistral-7b-instruct-v0.1", label: "mistralai/mistral-7b-instruct-v0.1" },
  { value: "mistralai/mistral-large", label: "mistralai/mistral-large" },
  { value: "mistralai/mistral-large-2407", label: "mistralai/mistral-large-2407" },
  { value: "mistralai/mistral-large-2411", label: "mistralai/mistral-large-2411" },
  { value: "mistralai/mistral-large-2512", label: "mistralai/mistral-large-2512" },
  { value: "mistralai/mistral-medium-3", label: "mistralai/mistral-medium-3" },
  { value: "mistralai/mistral-medium-3.1", label: "mistralai/mistral-medium-3.1" },
  { value: "mistralai/mistral-nemo", label: "mistralai/mistral-nemo" },
  { value: "mistralai/mistral-saba", label: "mistralai/mistral-saba" },
  { value: "mistralai/mistral-small-24b-instruct-2501", label: "mistralai/mistral-small-24b-instruct-2501" },
  { value: "mistralai/mistral-small-2603", label: "mistralai/mistral-small-2603" },
  { value: "mistralai/mistral-small-3.1-24b-instruct", label: "mistralai/mistral-small-3.1-24b-instruct" },
  { value: "mistralai/mistral-small-3.1-24b-instruct:free", label: "mistralai/mistral-small-3.1-24b-instruct:free" },
  { value: "mistralai/mistral-small-3.2-24b-instruct", label: "mistralai/mistral-small-3.2-24b-instruct" },
  { value: "mistralai/mistral-small-creative", label: "mistralai/mistral-small-creative" },
  { value: "mistralai/mixtral-8x22b-instruct", label: "mistralai/mixtral-8x22b-instruct" },
  { value: "mistralai/mixtral-8x7b-instruct", label: "mistralai/mixtral-8x7b-instruct" },
  { value: "mistralai/pixtral-large-2411", label: "mistralai/pixtral-large-2411" },
  { value: "mistralai/voxtral-small-24b-2507", label: "mistralai/voxtral-small-24b-2507" },
  { value: "moonshotai/kimi-k2", label: "moonshotai/kimi-k2" },
  { value: "moonshotai/kimi-k2-0905", label: "moonshotai/kimi-k2-0905" },
  { value: "moonshotai/kimi-k2-thinking", label: "moonshotai/kimi-k2-thinking" },
  { value: "moonshotai/kimi-k2.5", label: "moonshotai/kimi-k2.5" },
  { value: "morph/morph-v3-fast", label: "morph/morph-v3-fast" },
  { value: "morph/morph-v3-large", label: "morph/morph-v3-large" },
  { value: "nex-agi/deepseek-v3.1-nex-n1", label: "nex-agi/deepseek-v3.1-nex-n1" },
  { value: "nousresearch/hermes-2-pro-llama-3-8b", label: "nousresearch/hermes-2-pro-llama-3-8b" },
  { value: "nousresearch/hermes-3-llama-3.1-405b", label: "nousresearch/hermes-3-llama-3.1-405b" },
  { value: "nousresearch/hermes-3-llama-3.1-405b:free", label: "nousresearch/hermes-3-llama-3.1-405b:free" },
  { value: "nousresearch/hermes-3-llama-3.1-70b", label: "nousresearch/hermes-3-llama-3.1-70b" },
  { value: "nousresearch/hermes-4-405b", label: "nousresearch/hermes-4-405b" },
  { value: "nousresearch/hermes-4-70b", label: "nousresearch/hermes-4-70b" },
  { value: "nvidia/llama-3.1-nemotron-70b-instruct", label: "nvidia/llama-3.1-nemotron-70b-instruct" },
  { value: "nvidia/llama-3.3-nemotron-super-49b-v1.5", label: "nvidia/llama-3.3-nemotron-super-49b-v1.5" },
  { value: "nvidia/nemotron-3-nano-30b-a3b", label: "nvidia/nemotron-3-nano-30b-a3b" },
  { value: "nvidia/nemotron-3-nano-30b-a3b:free", label: "nvidia/nemotron-3-nano-30b-a3b:free" },
  { value: "nvidia/nemotron-3-super-120b-a12b:free", label: "nvidia/nemotron-3-super-120b-a12b:free" },
  { value: "nvidia/nemotron-nano-12b-v2-vl", label: "nvidia/nemotron-nano-12b-v2-vl" },
  { value: "nvidia/nemotron-nano-12b-v2-vl:free", label: "nvidia/nemotron-nano-12b-v2-vl:free" },
  { value: "nvidia/nemotron-nano-9b-v2", label: "nvidia/nemotron-nano-9b-v2" },
  { value: "nvidia/nemotron-nano-9b-v2:free", label: "nvidia/nemotron-nano-9b-v2:free" },
  { value: "openai/gpt-3.5-turbo", label: "openai/gpt-3.5-turbo" },
  { value: "openai/gpt-3.5-turbo-0613", label: "openai/gpt-3.5-turbo-0613" },
  { value: "openai/gpt-3.5-turbo-16k", label: "openai/gpt-3.5-turbo-16k" },
  { value: "openai/gpt-3.5-turbo-instruct", label: "openai/gpt-3.5-turbo-instruct" },
  { value: "openai/gpt-4", label: "openai/gpt-4" },
  { value: "openai/gpt-4-0314", label: "openai/gpt-4-0314" },
  { value: "openai/gpt-4-1106-preview", label: "openai/gpt-4-1106-preview" },
  { value: "openai/gpt-4-turbo", label: "openai/gpt-4-turbo" },
  { value: "openai/gpt-4-turbo-preview", label: "openai/gpt-4-turbo-preview" },
  { value: "openai/gpt-4.1", label: "openai/gpt-4.1" },
  { value: "openai/gpt-4.1-mini", label: "openai/gpt-4.1-mini" },
  { value: "openai/gpt-4.1-nano", label: "openai/gpt-4.1-nano" },
  { value: "openai/gpt-4o", label: "openai/gpt-4o" },
  { value: "openai/gpt-4o-2024-05-13", label: "openai/gpt-4o-2024-05-13" },
  { value: "openai/gpt-4o-2024-08-06", label: "openai/gpt-4o-2024-08-06" },
  { value: "openai/gpt-4o-2024-11-20", label: "openai/gpt-4o-2024-11-20" },
  { value: "openai/gpt-4o-audio-preview", label: "openai/gpt-4o-audio-preview" },
  { value: "openai/gpt-4o-mini", label: "openai/gpt-4o-mini" },
  { value: "openai/gpt-4o-mini-2024-07-18", label: "openai/gpt-4o-mini-2024-07-18" },
  { value: "openai/gpt-4o-mini-search-preview", label: "openai/gpt-4o-mini-search-preview" },
  { value: "openai/gpt-4o-search-preview", label: "openai/gpt-4o-search-preview" },
  { value: "openai/gpt-4o:extended", label: "openai/gpt-4o:extended" },
  { value: "openai/gpt-5", label: "openai/gpt-5" },
  { value: "openai/gpt-5-chat", label: "openai/gpt-5-chat" },
  { value: "openai/gpt-5-codex", label: "openai/gpt-5-codex" },
  { value: "openai/gpt-5-image", label: "openai/gpt-5-image" },
  { value: "openai/gpt-5-image-mini", label: "openai/gpt-5-image-mini" },
  { value: "openai/gpt-5-mini", label: "openai/gpt-5-mini" },
  { value: "openai/gpt-5-nano", label: "openai/gpt-5-nano" },
  { value: "openai/gpt-5-pro", label: "openai/gpt-5-pro" },
  { value: "openai/gpt-5.1", label: "openai/gpt-5.1" },
  { value: "openai/gpt-5.1-chat", label: "openai/gpt-5.1-chat" },
  { value: "openai/gpt-5.1-codex", label: "openai/gpt-5.1-codex" },
  { value: "openai/gpt-5.1-codex-max", label: "openai/gpt-5.1-codex-max" },
  { value: "openai/gpt-5.1-codex-mini", label: "openai/gpt-5.1-codex-mini" },
  { value: "openai/gpt-5.2", label: "openai/gpt-5.2" },
  { value: "openai/gpt-5.2-chat", label: "openai/gpt-5.2-chat" },
  { value: "openai/gpt-5.2-codex", label: "openai/gpt-5.2-codex" },
  { value: "openai/gpt-5.2-pro", label: "openai/gpt-5.2-pro" },
  { value: "openai/gpt-5.3-chat", label: "openai/gpt-5.3-chat" },
  { value: "openai/gpt-5.3-codex", label: "openai/gpt-5.3-codex" },
  { value: "openai/gpt-5.4", label: "openai/gpt-5.4" },
  { value: "openai/gpt-5.4-mini", label: "openai/gpt-5.4-mini" },
  { value: "openai/gpt-5.4-nano", label: "openai/gpt-5.4-nano" },
  { value: "openai/gpt-5.4-pro", label: "openai/gpt-5.4-pro" },
  { value: "openai/gpt-audio", label: "openai/gpt-audio" },
  { value: "openai/gpt-audio-mini", label: "openai/gpt-audio-mini" },
  { value: "openai/gpt-oss-120b", label: "openai/gpt-oss-120b" },
  { value: "openai/gpt-oss-120b:free", label: "openai/gpt-oss-120b:free" },
  { value: "openai/gpt-oss-20b", label: "openai/gpt-oss-20b" },
  { value: "openai/gpt-oss-20b:free", label: "openai/gpt-oss-20b:free" },
  { value: "openai/gpt-oss-safeguard-20b", label: "openai/gpt-oss-safeguard-20b" },
  { value: "openai/o1", label: "openai/o1" },
  { value: "openai/o1-pro", label: "openai/o1-pro" },
  { value: "openai/o3", label: "openai/o3" },
  { value: "openai/o3-deep-research", label: "openai/o3-deep-research" },
  { value: "openai/o3-mini", label: "openai/o3-mini" },
  { value: "openai/o3-mini-high", label: "openai/o3-mini-high" },
  { value: "openai/o3-pro", label: "openai/o3-pro" },
  { value: "openai/o4-mini", label: "openai/o4-mini" },
  { value: "openai/o4-mini-deep-research", label: "openai/o4-mini-deep-research" },
  { value: "openai/o4-mini-high", label: "openai/o4-mini-high" },
  { value: "openrouter/auto", label: "openrouter/auto" },
  { value: "openrouter/bodybuilder", label: "openrouter/bodybuilder" },
  { value: "openrouter/free", label: "openrouter/free" },
  { value: "openrouter/healer-alpha", label: "openrouter/healer-alpha" },
  { value: "openrouter/hunter-alpha", label: "openrouter/hunter-alpha" },
  { value: "perplexity/sonar", label: "perplexity/sonar" },
  { value: "perplexity/sonar-deep-research", label: "perplexity/sonar-deep-research" },
  { value: "perplexity/sonar-pro", label: "perplexity/sonar-pro" },
  { value: "perplexity/sonar-pro-search", label: "perplexity/sonar-pro-search" },
  { value: "perplexity/sonar-reasoning-pro", label: "perplexity/sonar-reasoning-pro" },
  { value: "prime-intellect/intellect-3", label: "prime-intellect/intellect-3" },
  { value: "qwen/qwen-2.5-72b-instruct", label: "qwen/qwen-2.5-72b-instruct" },
  { value: "qwen/qwen-2.5-7b-instruct", label: "qwen/qwen-2.5-7b-instruct" },
  { value: "qwen/qwen-2.5-coder-32b-instruct", label: "qwen/qwen-2.5-coder-32b-instruct" },
  { value: "qwen/qwen-2.5-vl-7b-instruct", label: "qwen/qwen-2.5-vl-7b-instruct" },
  { value: "qwen/qwen-max", label: "qwen/qwen-max" },
  { value: "qwen/qwen-plus", label: "qwen/qwen-plus" },
  { value: "qwen/qwen-plus-2025-07-28", label: "qwen/qwen-plus-2025-07-28" },
  { value: "qwen/qwen-plus-2025-07-28:thinking", label: "qwen/qwen-plus-2025-07-28:thinking" },
  { value: "qwen/qwen-turbo", label: "qwen/qwen-turbo" },
  { value: "qwen/qwen-vl-max", label: "qwen/qwen-vl-max" },
  { value: "qwen/qwen-vl-plus", label: "qwen/qwen-vl-plus" },
  { value: "qwen/qwen2.5-coder-7b-instruct", label: "qwen/qwen2.5-coder-7b-instruct" },
  { value: "qwen/qwen2.5-vl-32b-instruct", label: "qwen/qwen2.5-vl-32b-instruct" },
  { value: "qwen/qwen2.5-vl-72b-instruct", label: "qwen/qwen2.5-vl-72b-instruct" },
  { value: "qwen/qwen3-14b", label: "qwen/qwen3-14b" },
  { value: "qwen/qwen3-235b-a22b", label: "qwen/qwen3-235b-a22b" },
  { value: "qwen/qwen3-235b-a22b-2507", label: "qwen/qwen3-235b-a22b-2507" },
  { value: "qwen/qwen3-235b-a22b-thinking-2507", label: "qwen/qwen3-235b-a22b-thinking-2507" },
  { value: "qwen/qwen3-30b-a3b", label: "qwen/qwen3-30b-a3b" },
  { value: "qwen/qwen3-30b-a3b-instruct-2507", label: "qwen/qwen3-30b-a3b-instruct-2507" },
  { value: "qwen/qwen3-30b-a3b-thinking-2507", label: "qwen/qwen3-30b-a3b-thinking-2507" },
  { value: "qwen/qwen3-32b", label: "qwen/qwen3-32b" },
  { value: "qwen/qwen3-4b:free", label: "qwen/qwen3-4b:free" },
  { value: "qwen/qwen3-8b", label: "qwen/qwen3-8b" },
  { value: "qwen/qwen3-coder", label: "qwen/qwen3-coder" },
  { value: "qwen/qwen3-coder-30b-a3b-instruct", label: "qwen/qwen3-coder-30b-a3b-instruct" },
  { value: "qwen/qwen3-coder-flash", label: "qwen/qwen3-coder-flash" },
  { value: "qwen/qwen3-coder-next", label: "qwen/qwen3-coder-next" },
  { value: "qwen/qwen3-coder-plus", label: "qwen/qwen3-coder-plus" },
  { value: "qwen/qwen3-coder:free", label: "qwen/qwen3-coder:free" },
  { value: "qwen/qwen3-max", label: "qwen/qwen3-max" },
  { value: "qwen/qwen3-max-thinking", label: "qwen/qwen3-max-thinking" },
  { value: "qwen/qwen3-next-80b-a3b-instruct", label: "qwen/qwen3-next-80b-a3b-instruct" },
  { value: "qwen/qwen3-next-80b-a3b-instruct:free", label: "qwen/qwen3-next-80b-a3b-instruct:free" },
  { value: "qwen/qwen3-next-80b-a3b-thinking", label: "qwen/qwen3-next-80b-a3b-thinking" },
  { value: "qwen/qwen3-vl-235b-a22b-instruct", label: "qwen/qwen3-vl-235b-a22b-instruct" },
  { value: "qwen/qwen3-vl-235b-a22b-thinking", label: "qwen/qwen3-vl-235b-a22b-thinking" },
  { value: "qwen/qwen3-vl-30b-a3b-instruct", label: "qwen/qwen3-vl-30b-a3b-instruct" },
  { value: "qwen/qwen3-vl-30b-a3b-thinking", label: "qwen/qwen3-vl-30b-a3b-thinking" },
  { value: "qwen/qwen3-vl-32b-instruct", label: "qwen/qwen3-vl-32b-instruct" },
  { value: "qwen/qwen3-vl-8b-instruct", label: "qwen/qwen3-vl-8b-instruct" },
  { value: "qwen/qwen3-vl-8b-thinking", label: "qwen/qwen3-vl-8b-thinking" },
  { value: "qwen/qwen3.5-122b-a10b", label: "qwen/qwen3.5-122b-a10b" },
  { value: "qwen/qwen3.5-27b", label: "qwen/qwen3.5-27b" },
  { value: "qwen/qwen3.5-35b-a3b", label: "qwen/qwen3.5-35b-a3b" },
  { value: "qwen/qwen3.5-397b-a17b", label: "qwen/qwen3.5-397b-a17b" },
  { value: "qwen/qwen3.5-9b", label: "qwen/qwen3.5-9b" },
  { value: "qwen/qwen3.5-flash-02-23", label: "qwen/qwen3.5-flash-02-23" },
  { value: "qwen/qwen3.5-plus-02-15", label: "qwen/qwen3.5-plus-02-15" },
  { value: "qwen/qwq-32b", label: "qwen/qwq-32b" },
  { value: "relace/relace-apply-3", label: "relace/relace-apply-3" },
  { value: "relace/relace-search", label: "relace/relace-search" },
  { value: "sao10k/l3-euryale-70b", label: "sao10k/l3-euryale-70b" },
  { value: "sao10k/l3-lunaris-8b", label: "sao10k/l3-lunaris-8b" },
  { value: "sao10k/l3.1-70b-hanami-x1", label: "sao10k/l3.1-70b-hanami-x1" },
  { value: "sao10k/l3.1-euryale-70b", label: "sao10k/l3.1-euryale-70b" },
  { value: "sao10k/l3.3-euryale-70b", label: "sao10k/l3.3-euryale-70b" },
  { value: "stepfun/step-3.5-flash", label: "stepfun/step-3.5-flash" },
  { value: "stepfun/step-3.5-flash:free", label: "stepfun/step-3.5-flash:free" },
  { value: "switchpoint/router", label: "switchpoint/router" },
  { value: "tencent/hunyuan-a13b-instruct", label: "tencent/hunyuan-a13b-instruct" },
  { value: "thedrummer/cydonia-24b-v4.1", label: "thedrummer/cydonia-24b-v4.1" },
  { value: "thedrummer/rocinante-12b", label: "thedrummer/rocinante-12b" },
  { value: "thedrummer/skyfall-36b-v2", label: "thedrummer/skyfall-36b-v2" },
  { value: "thedrummer/unslopnemo-12b", label: "thedrummer/unslopnemo-12b" },
  { value: "tngtech/deepseek-r1t2-chimera", label: "tngtech/deepseek-r1t2-chimera" },
  { value: "undi95/remm-slerp-l2-13b", label: "undi95/remm-slerp-l2-13b" },
  { value: "upstage/solar-pro-3", label: "upstage/solar-pro-3" },
  { value: "writer/palmyra-x5", label: "writer/palmyra-x5" },
  { value: "x-ai/grok-3", label: "x-ai/grok-3" },
  { value: "x-ai/grok-3-beta", label: "x-ai/grok-3-beta" },
  { value: "x-ai/grok-3-mini", label: "x-ai/grok-3-mini" },
  { value: "x-ai/grok-3-mini-beta", label: "x-ai/grok-3-mini-beta" },
  { value: "x-ai/grok-4", label: "x-ai/grok-4" },
  { value: "x-ai/grok-4-fast", label: "x-ai/grok-4-fast" },
  { value: "x-ai/grok-4.1-fast", label: "x-ai/grok-4.1-fast" },
  { value: "x-ai/grok-4.20-beta", label: "x-ai/grok-4.20-beta" },
  { value: "x-ai/grok-4.20-multi-agent-beta", label: "x-ai/grok-4.20-multi-agent-beta" },
  { value: "x-ai/grok-code-fast-1", label: "x-ai/grok-code-fast-1" },
  { value: "xiaomi/mimo-v2-flash", label: "xiaomi/mimo-v2-flash" },
  { value: "z-ai/glm-4-32b", label: "z-ai/glm-4-32b" },
  { value: "z-ai/glm-4.5", label: "z-ai/glm-4.5" },
  { value: "z-ai/glm-4.5-air", label: "z-ai/glm-4.5-air" },
  { value: "z-ai/glm-4.5-air:free", label: "z-ai/glm-4.5-air:free" },
  { value: "z-ai/glm-4.5v", label: "z-ai/glm-4.5v" },
  { value: "z-ai/glm-4.6", label: "z-ai/glm-4.6" },
  { value: "z-ai/glm-4.6v", label: "z-ai/glm-4.6v" },
  { value: "z-ai/glm-4.7", label: "z-ai/glm-4.7" },
  { value: "z-ai/glm-4.7-flash", label: "z-ai/glm-4.7-flash" },
  { value: "z-ai/glm-5", label: "z-ai/glm-5" },
  { value: "z-ai/glm-5-turbo", label: "z-ai/glm-5-turbo" },
];
